{
    "email": "Votre email",
    "choose_pass": "Choisissez un mot de passe",
    "confirm_pass": "Confirmez le mot de passe",
    "passwords_mismatch": "Les mots de passe ne correspondent pas.",
    "passwords_match": "Les mots de passe sont identiques",
    "success": "Mot de passe modifié avec succès !",
    "validator": {
        "uppercase": "Maj.",
        "lowercase": "Min.",
        "figure": "Chiffre",
        "special_character": "Caractère spécial",
        "size": "Taille (min. 12)"
    }
}